<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-公司-添加
    -->
    <el-dialog
    title="修改公司"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
    :append-to-body="true"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" label-width="100px">
      <el-form-item label="企业名称" prop="company" :rules="[{ required: true, message: '请输入企业名称' }]">
      <el-input v-model="form.company" placeholder="请输入企业名称" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="登记状态" prop="op_status">
      <el-input v-model="form.op_status" placeholder="请输入登记状态" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="法定代表人" prop="lawer">
      <el-input v-model="form.lawer" placeholder="请输入法定代表人" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="注册资本" prop="capital">
      <el-input v-model="form.capital" placeholder="请输入注册资本" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="成立日期" prop="reg_date">
      <el-input v-model="form.reg_date" placeholder="请输入成立日期" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="统一社会信用代码" prop="credit_code">
      <el-input v-model="form.credit_code" placeholder="请输入统一社会信用代码" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="企业注册地址" prop="reg_address">
      <el-input v-model="form.reg_address" placeholder="请输入企业注册地址" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="电话" prop="phone">
      <el-input v-model="form.phone" placeholder="请输入电话" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="更多电话" prop="phone_more">
      <el-input v-model="form.phone_more" placeholder="请输入更多电话" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="邮箱" prop="mail">
      <el-input v-model="form.mail" placeholder="请输入邮箱" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="更多邮箱" prop="mail_more">
      <el-input v-model="form.mail_more" placeholder="请输入更多邮箱" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="所属省份" prop="province">
      <el-input v-model="form.province" placeholder="请输入所属省份" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="所属城市" prop="city">
      <el-input v-model="form.city" placeholder="请输入所属城市" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="所属区县" prop="region">
      <el-input v-model="form.region" placeholder="请输入所属区县" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="纳税人识别号" prop="tax_id">
      <el-input v-model="form.tax_id" placeholder="请输入纳税人识别号" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="注册号" prop="red_id">
      <el-input v-model="form.red_id" placeholder="请输入注册号" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="组织机构代码" prop="org_id">
      <el-input v-model="form.org_id" placeholder="请输入组织机构代码" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="参保人数量" prop="Insured">
      <el-input v-model="form.Insured" placeholder="请输入参保人数量" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="参保人数" prop="Insured_value">
      <el-input v-model="form.Insured_value" placeholder="请输入参保人数" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="参保人数所属年报" prop="Insured_year">
      <el-input v-model="form.Insured_year" placeholder="请输入参保人数所属年报" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="企业(机构)类型" prop="org_type">
      <el-input v-model="form.org_type" placeholder="请输入企业(机构)类型" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="企业规模" prop="scale">
      <el-input v-model="form.scale" placeholder="请输入企业规模" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="核准日期" prop="approval_date">
      <el-input v-model="form.approval_date" placeholder="请输入核准日期" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="营业期限" prop="term">
      <el-input v-model="form.term" placeholder="请输入营业期限" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="国标行业门类" prop="industry">
      <el-input v-model="form.industry" placeholder="请输入国标行业门类" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="国标行业大类" prop="category_1">
      <el-input v-model="form.category_1" placeholder="请输入国标行业大类" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="国标行业中类" prop="category_2">
      <el-input v-model="form.category_2" placeholder="请输入国标行业中类" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="国标行业小类" prop="category_3">
      <el-input v-model="form.category_3" placeholder="请输入国标行业小类" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="曾用名" prop="former_name">
      <el-input v-model="form.former_name" placeholder="请输入曾用名" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="英文名" prop="en_name">
      <el-input v-model="form.en_name" placeholder="请输入英文名" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="官网网址" prop="url">
      <el-input v-model="form.url" placeholder="请输入官网网址" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="通信地址" prop="address">
      <el-input v-model="form.address" placeholder="请输入通信地址" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="企业简介" prop="intro">
      <el-input v-model="form.intro" placeholder="请输入企业简介" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="经营范围" prop="scope">
      <el-input v-model="form.scope" placeholder="请输入经营范围" class="max-w460"></el-input>
    </el-form-item>



      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>

     <!--上传图片组件-->
     <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
    <GetUser :is_open="open_user" :multi="false" @close="closeDialogFunc"></GetUser>
</el-dialog>

</template>

<script>
import Getpoint from '@/components/map/Getpoint.vue';
import CompanyApi from '@/api/company.js';
import Upload from '@/components/file/Upload';
import GetUser from '@/components/user/GetUser.vue';
var timestamp=new Date().toLocaleDateString();
export default {
  components: {
    Upload,
    Getpoint,
    GetUser,
  },
  data() {
    return {

      /*form表单数据*/
      form: {

company:"",
op_status:"",
lawer:"",
capital:"",
reg_date:"",
credit_code:"",
reg_address:"",
phone:"",
phone_more:"",
mail:"",
mail_more:"",
province:"",
city:"",
region:"",
tax_id:"",
red_id:"",
org_id:"",
Insured:"",
Insured_value:"",
Insured_year:"",
org_type:"",
scale:"",
approval_date:"",
term:"",
industry:"",
category_1:"",
category_2:"",
category_3:"",
former_name:"",
en_name:"",
url:"",
address:"",
intro:"",
scope:"",


      },
      loading: false,
      dialogVisible:false,
       /*是否上传图片*/
      isupload: false,
      isImg: false,
      category:[],
      user_info:{
        avatarUrl:"",
        nickName:""
      },
      open_user:false,
    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
    this.getDetail();
    this.getCategory()
  },
  props: ["open_add","company_id"],
  methods: {
       /*打开弹出层*/
       addClick() {
        this.open_user = true;
      },
       /*关闭获取用户弹窗*/
       closeDialogFunc(e) {
        console.log("e",e)
        if (e.type != 'error') {
          this.user_info = e.params;
          this.form.user_id = e.params.user_id;
        }
        this.open_user = false;
      },
      remove(){
        console.log("移除");
        this.user_info = {
          nickName:"",
          avatarUrl:""
        }
        this.form.user_id = "";
      },

       /*获取经纬度*/
       getMapdataFunc(e) {
        this.form.coordinate = e.data[0].toFixed(6) + ',' + e.data[1].toFixed(6);
      },

      /*选择的地址*/
      choseFunc(e){
        this.form.coordinate=e.location.lat+','+e.location.lng;
        this.form.latitude = e.location.lat;
        this.form.longitude = e.location.lng;
        this.form.detail=e.address;

      },
    /*上传*/
    openUpload(upload_type) {
      this.isupload = true;
    },


    /*获取图片*/
    returnImgsFunc(e) {
      let self = this;
      if (e != null) {
        this.form.image_id = e[0].file_id;
        this.form.image_url = e[0].file_path;
        this.isImg = true;

      }
      this.isupload = false;
    },

      /*获取行业分类*/
      getCategory() {
        // console.log(444);return
        CompanyApi.getCategory('', true)
          .then(res => {
            this.category = res.data.category;
          })
          .catch(error => {

          });
      },
     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", {});
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },
    getDetail() {
      let self = this;
      // 取到路由带过来的参数
      CompanyApi.detail({company_id: self.company_id},true).then(res => {
          self.form = res.data;
          self.user_info = res.data.user_info
          self.loading = false;
          if(self.form.image_url){
            self.isImg = true;
          }

        })
        .catch(error => {});
    },
    onSubmit() {
      let self = this;
      let form = self.form;
      form.company_id = self.company_id;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          CompanyApi.edit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    }
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/company/part/edit.vue